import { type Common } from '../common.js';
import {
  type FlowRunSignal,
  type QueryParams as FlowRunSignalQueryParams,
} from '../models/flow/flowRunSignal.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/flow-runs/signals';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(queryParams?: FlowRunSignalQueryParams): Promise<FlowRunSignal[]> {
    const url = this.common.constructPath(this.baseEndpoint, queryParams);
    return await this.common.getJSON(url);
  }

  async findOneById(signalId: string): Promise<FlowRunSignal> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${signalId}`);
    return await this.common.getJSON(url);
  }
}
